import { Component, Element, h, Host, Method, Prop } from '@stencil/core';
import i18next, { i18n, TFunction } from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import { SiteI18nConfig } from '../../models/i18n';
import SySiteBackend from './sy-site-i18next-backend';
import SySiteLanguageDetector from './sy-site-i18next-detector';
@Component({
  tag: 'sy-site-i18n',
  shadow: false,
})
export class SySiteI18n {

  static i18n: i18n = i18next.createInstance();
  static t: TFunction = SySiteI18n.i18n.t.bind(SySiteI18n.i18n);

  @Element() host: HTMLSySiteI18nElement;

  private isReadyResolve = null;
  private isReady = new Promise(resolve => {
    this.isReadyResolve = resolve;
  });

  private catalogByLanguage: any;

  @Prop() siteApi!: HTMLSySiteApiElement;

  /**
   * _id of Site portal
   */
  @Prop() portalId: string;

  /**
   * Translation function
   */
  @Prop({ mutable: true }) t: TFunction;

  /**
   * i18next i18n instance
   */
  @Prop({ mutable: true }) i18n: i18n;

  @Method()
  whenReady(): Promise<any> {
    return this.isReady;
  }

  componentWillLoad() {
    this.i18n = SySiteI18n.i18n;
    this.t = SySiteI18n.t;

    const catalogByLanguagePromise = this.siteApi.getSiteI18nConfig(this.portalId)
      .then((siteI18nConfig: SiteI18nConfig) => {
        this.catalogByLanguage = siteI18nConfig.catalogByLanguage;
        return this.catalogByLanguage;
      });

    SySiteI18n.i18n
      .use(SySiteLanguageDetector)
      .use(ChainedBackend)
      .init({
        ns: ['site'],
        defaultNS: 'site',
        fallbackLng: false,
        backend: {
          backends: [
            LocalStorageBackend,
            SySiteBackend
          ],
          backendOptions: [
            {
              expirationTime: 7 * 24 * 60 * 60 * 1000, // uma semana
              // expirationTime: 0.1 * 60 * 1000, // 0,1 minuto
            },
            {
              siteApi: this.siteApi
            }
          ]
        },
        detection: {
          catalogByLanguagePromise: catalogByLanguagePromise
        }
      })
      .then((_t) => {
        this.isReadyResolve();
      });

    window.addEventListener('popstate', (_e: PopStateEvent) => {
      const findLangByPath = (languagePath) => {
        return this.catalogByLanguage.find(config => config.path === languagePath)?.language;
      };

      const languagePath = window.location.pathname.split("/").find(path => path.match(/^([a-z]{2})$/)) ?? null;
      
      this.i18n.changeLanguage(findLangByPath(languagePath) ?? "en");
      
    });
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host >
    );
  }

}
